// Preset dropdown labels for the Report Builder form.
// Backend ALWAYS receives the English `value` — the AR `label` is only
// for display. This way existing reports and the AI generator keep
// working while AR users see Arabic in the dropdowns.
//
// Usage:
//   import { getSectors, getCountries, getSizes, getCurrencies, getRoles,
//            getYesNoDev, getYesNoCompliance } from "@/lib/presets";
//   const sectors = getSectors(lang);  // [{value, label}, ...]

export const SECTORS = [
  { value: "Construction & Real Estate", ar: "الإنشاءات والعقارات" },
  { value: "Manufacturing",              ar: "الصناعات التحويلية" },
  { value: "Retail & Trade",             ar: "التجزئة والتجارة" },
  { value: "Financial Services",         ar: "الخدمات المالية" },
  { value: "Hospitality & Tourism",      ar: "الضيافة والسياحة" },
  { value: "Transport & Logistics",      ar: "النقل والخدمات اللوجستية" },
  { value: "Oil & Gas / Energy",         ar: "النفط والغاز / الطاقة" },
  { value: "Technology",                 ar: "التكنولوجيا" },
  { value: "Healthcare",                 ar: "الرعاية الصحية" },
  { value: "Food & Beverage",            ar: "الأغذية والمشروبات" },
  { value: "Education",                  ar: "التعليم" },
  { value: "Other",                      ar: "أخرى" },
];

export const COUNTRIES = [
  { value: "UAE",           ar: "الإمارات العربية المتحدة" },
  { value: "Saudi Arabia",  ar: "المملكة العربية السعودية" },
  { value: "Qatar",         ar: "قطر" },
  { value: "Kuwait",        ar: "الكويت" },
  { value: "Oman",          ar: "عُمان" },
  { value: "Bahrain",       ar: "البحرين" },
  { value: "Other Country", ar: "دولة أخرى" },
];

export const SIZES = [
  { value: "1-10",    ar: "1-10" },
  { value: "11-50",   ar: "11-50" },
  { value: "51-200",  ar: "51-200" },
  { value: "201-500", ar: "201-500" },
  { value: "500+",    ar: "+500" },
];

export const CURRENCIES = [
  { value: "AED", ar: "د.إ ، درهم إماراتي",   en: "AED, UAE Dirham" },
  { value: "SAR", ar: "ر.س ، ريال سعودي",     en: "SAR, Saudi Riyal" },
  { value: "QAR", ar: "ر.ق ، ريال قطري",      en: "QAR, Qatari Riyal" },
  { value: "KWD", ar: "د.ك ، دينار كويتي",    en: "KWD, Kuwaiti Dinar" },
  { value: "OMR", ar: "ر.ع ، ريال عُماني",    en: "OMR, Omani Rial" },
  { value: "BHD", ar: "د.ب ، دينار بحريني",   en: "BHD, Bahraini Dinar" },
  { value: "USD", ar: "دولار أمريكي",          en: "USD, US Dollar" },
  { value: "EUR", ar: "يورو",                  en: "EUR, Euro" },
  { value: "GBP", ar: "جنيه إسترليني",         en: "GBP, British Pound" },
];

export const CEO_ROLES = [
  { value: "CEO",                          ar: "الرئيس التنفيذي" },
  { value: "Chairman",                     ar: "رئيس مجلس الإدارة" },
  { value: "Managing Director",            ar: "العضو المنتدب" },
  { value: "Chief Sustainability Officer", ar: "مدير الاستدامة التنفيذي" },
  { value: "Founder",                      ar: "المؤسس" },
  { value: "Partner",                      ar: "الشريك" },
  { value: "President",                    ar: "الرئيس" },
  { value: "Executive Director",           ar: "المدير التنفيذي" },
];

export const CLIMATE_ALIGN = [
  { value: "1.5C",              ar: "متوافق مع مسار 1.5°م (SBTi أو ما يعادلها)",   en: "Aligned with 1.5°C pathway (SBTi or equivalent)" },
  { value: "2C",                ar: "متوافق مع مسار 2°م (أقل من 2°م)",             en: "Aligned with 2°C pathway (well-below 2°C)" },
  { value: "under_development", ar: "قيد التطوير (التزام قائم، الأهداف تُحدَّد)",  en: "Under development (commitment made, target-setting in progress)" },
  { value: "not_yet",           ar: "غير متوافق بعد / لم تُحدَّد الأهداف",         en: "Not yet aligned / targets not set" },
];

// Policy radio groups (3 variants)
export const YES_FORMAL_IN_DEV_NO = [
  { value: "Yes, Formal policy in place", ar: "نعم، سياسة رسمية قائمة",       en: "Yes, Formal policy" },
  { value: "In Development",              ar: "قيد التطوير",                 en: "In Development" },
  { value: "No",                          ar: "لا",                           en: "No" },
];

export const YES_ZERO_IN_DEV_NO = [
  { value: "Yes, Zero tolerance policy", ar: "نعم، سياسة عدم تهاون",         en: "Yes, Zero tolerance" },
  { value: "In Development",             ar: "قيد التطوير",                  en: "In Development" },
  { value: "No",                         ar: "لا",                            en: "No" },
];

export const YES_ANON_IN_DEV_NO = [
  { value: "Yes, Anonymous reporting channel available", ar: "نعم، قناة إبلاغ مجهولة متاحة", en: "Yes, Anonymous channel" },
  { value: "In Development",                             ar: "قيد التطوير",                 en: "In Development" },
  { value: "No",                                         ar: "لا",                           en: "No" },
];

export const YES_COMPLIANT_IN_DEV_NO = [
  { value: "Yes, PDPL/GDPR compliant", ar: "نعم، متوافق مع PDPL/GDPR", en: "Yes, PDPL/GDPR compliant" },
  { value: "In Development",           ar: "قيد التطوير",             en: "In Development" },
  { value: "No",                       ar: "لا",                       en: "No" },
];

// Data-quality radio
export const DQ_OPTIONS = [
  { v: "verified",  en: "Verified",         ar: "موثَّق",            desc_en: "Audited / source-documented",    desc_ar: "مُدقَّق / موثَّق بالمصادر" },
  { v: "estimated", en: "Estimated",        ar: "تقدير",             desc_en: "Company best estimate",            desc_ar: "أفضل تقدير للشركة" },
  { v: "review",    en: "Requires Review",  ar: "يحتاج مراجعة",      desc_en: "Placeholder / needs checking",     desc_ar: "مؤقت / يحتاج تحققاً" },
];

// Localized option list — pass lang → returns [{value, label}, …]
const pick = (list, lang, field = "ar") =>
  list.map((o) => ({ value: o.value, label: lang === "ar" ? o[field] : (o.en || o.value) }));

export const getSectors    = (lang) => pick(SECTORS, lang);
export const getCountries  = (lang) => pick(COUNTRIES, lang);
export const getSizes      = (lang) => pick(SIZES, lang);
export const getCurrencies = (lang) => pick(CURRENCIES, lang);
export const getCeoRoles   = (lang) => pick(CEO_ROLES, lang);
export const getClimateAlign = (lang) => pick(CLIMATE_ALIGN, lang);
export const getYesFormal    = (lang) => pick(YES_FORMAL_IN_DEV_NO, lang);
export const getYesZero      = (lang) => pick(YES_ZERO_IN_DEV_NO, lang);
export const getYesAnon      = (lang) => pick(YES_ANON_IN_DEV_NO, lang);
export const getYesCompliant = (lang) => pick(YES_COMPLIANT_IN_DEV_NO, lang);
